import * as React from 'react';
import { selectFilters } from '../../selectors/filters';
import { IReduxStore } from '../../types/redux';
import { IBrowserHistoryState } from '../../types/browserHistory';

export const useLocationInit = (store: IReduxStore) => {
  React.useEffect(() => {
    const state = store.getState();
    const filters = selectFilters(state);

    history.replaceState({ filters, url: window.location.href } as IBrowserHistoryState, '', window.location.href);
  }, []);
};
